export default "__VITE_ASSET__BKUHSb7p__"